import { useState, createContext, useContext } from 'react';
import type { ReactElement, ReactNode, Dispatch, SetStateAction } from 'react';

export interface StoryblokEditorContextType {
  isInEditorMode: boolean;
  setIsInEditorMode: Dispatch<SetStateAction<boolean>>;
}

const StoryblokEditorContext = createContext<StoryblokEditorContextType>({
  isInEditorMode: false,
  setIsInEditorMode: () => {
    throw new Error('You forgot to wrap this in a StoryblokEditor object');
  },
});

export function useStoryblokEditorContext(): StoryblokEditorContextType {
  return useContext(StoryblokEditorContext);
}

export interface StoryblokEditorProps {
  children: ReactNode;
}

export function StoryblokEditor(props: StoryblokEditorProps): ReactElement {
  const [isInEditorMode, setIsInEditorMode] = useState(false);

  return (
    <StoryblokEditorContext.Provider
      value={{
        isInEditorMode,
        setIsInEditorMode,
      }}
    >
      {props.children}
    </StoryblokEditorContext.Provider>
  );
}
